import React from "react";

const DateCard = ({ heading, subheading, description, date }) => {
    return (
        <div className="flex flex-col w-full border-gray-200 border-solid border-2 rounded-sm px-8 py-8 font-montserrat h-full">
            <div className="flex flex-col mb-6">
                <h2 className="text-green-700 text-[42px] leading-8 md:text-2xl sm:text-xl font-bold"> {heading} </h2>
                <h3 className="text-green-700 text-xl md:text-1xl sm:text-base font-bold"> {subheading} </h3>
            </div>
            <p className="max-w-[50%] md:max-w-[75%] font-semibold text-gray-700 leading-5"> {description} </p>
            <p className="mt-1 text-sm font-regular text-gray-700"> {date} </p>
        </div>
    )
}

export default DateCard;